// extracted by mini-css-extract-plugin
module.exports = {"tag":"AddressTypeTag_tag__1h4f3","content":"AddressTypeTag_content__1fIEN"};